import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "measurement-history-panel" }
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "panel-title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "panel-content" }
const _hoisted_6 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_7 = {
  key: 1,
  class: "measurement-list"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "measurement-icon" }
const _hoisted_10 = { class: "measurement-details" }
const _hoisted_11 = { class: "measurement-type" }
const _hoisted_12 = { class: "measurement-value" }
const _hoisted_13 = {
  key: 0,
  class: "measurement-page"
}
const _hoisted_14 = ["title", "onClick"]
const _hoisted_15 = {
  key: 0,
  class: "panel-footer"
}

import { useI18n } from 'vue-i18n';
import AppButton from '@/components/base/AppButton.vue';

interface Measurement {
  type: 'distance' | 'area' | 'polygon';
  value: string;
  pageNumber?: number;
}

interface Props {
  measurements: Measurement[];
  selectedIndex?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MeasurementHistoryPanel',
  props: {
    measurements: {},
    selectedIndex: {}
  },
  emits: ["measurement-select", "measurement-delete", "clear-all", "export"],
  setup(__props: any) {





const { t } = useI18n();

const getMeasurementIcon = (type: string): string => {
  switch (type) {
    case 'distance':
      return 'fas fa-ruler';
    case 'area':
      return 'fas fa-draw-polygon';
    case 'polygon':
      return 'fas fa-shapes';
    default:
      return 'fas fa-ruler-combined';
  }
};

const getMeasurementTypeName = (type: string): string => {
  switch (type) {
    case 'distance':
      return t('annotation.distance');
    case 'area':
      return t('annotation.area');
    case 'polygon':
      return t('annotation.polygonArea');
    default:
      return t('annotation.measurement');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-ruler-combined" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('annotation.measurements')), 1)
      ]),
      (_ctx.measurements.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-clear",
            title: _ctx.$t('annotation.clearAll'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear-all')))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
          ]))], 8, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.measurements.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-ruler-combined" }, null, -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('annotation.noMeasurements')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measurements, (measurement, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["measurement-item", { selected: _ctx.selectedIndex === index }]),
                onClick: ($event: any) => (_ctx.$emit('measurement-select', index))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("i", {
                    class: _normalizeClass(getMeasurementIcon(measurement.type))
                  }, null, 2)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(getMeasurementTypeName(measurement.type)), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(measurement.value), 1),
                  (measurement.pageNumber)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Page " + _toDisplayString(measurement.pageNumber), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", {
                  class: "btn-delete",
                  title: _ctx.$t('common.delete'),
                  onClick: _withModifiers(($event: any) => (_ctx.$emit('measurement-delete', index)), ["stop"])
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))], 8, _hoisted_14)
              ], 10, _hoisted_8))
            }), 128))
          ]))
    ]),
    (_ctx.measurements.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(AppButton, {
            variant: "outline",
            size: "small",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('export')))
          }, {
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-file-export" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('annotation.exportMeasurements')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})